import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import CUSTOM_PARAMETERS from './CUSTOM_PARAMETERS';
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";

  // refactored - keep using KAMPYLE_FUNC.getCustomParamValue - this function not tested enough yet.
  function getCustomParamValue(customParam) {
    if(!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CP_EXT_REFACTOR)) {
      return KAMPYLE_FUNC.getSafeCustomParamVal(customParam)
    }
    var cp = customParam || {};
    var extractedValue = CUSTOM_PARAMETERS.extractCPValue(cp);
    return CUSTOM_PARAMETERS.castCPValue(extractedValue, cp.type || '');
  }

  function formatCustomParams(formId) {
    var customParams = CUSTOM_PARAMETERS.getFormCustomParams(formId) || [];
    return customParams.map(CUSTOM_PARAMETERS.appendValueToCPObject);
  }

  function getFormCustomParams(formId) {
    var allCustomParams = MDIGITAL_CONFIGURATION.getOnsiteConfiguration().customParams || [];
    var formData = KAMPYLE_DATA.getFormData(formId) || {};
    if (!hasCustomParams(formId)) { return null; }
    return formData.customParams.map(formCustomParamsId => allCustomParams.find(cp => cp.id === formCustomParamsId));
  }

  function hasCustomParams(formId) {
    var formData = KAMPYLE_DATA.getFormData(formId);
    return !!formData && !!formData.customParams && Array.isArray(formData.customParams) && !!formData.customParams.length;
  }

  function getAllCustomParams() {
    return MDIGITAL_CONFIGURATION.getOnsiteConfiguration().customParams || [];
  }

  function getCustomParamValueByUniqueName(uniqueName) {
    var customParam = CUSTOM_PARAMETERS.getCustomParamByUniqueName(uniqueName) || {};
    return CUSTOM_PARAMETERS.getCustomParamValue(customParam);
  }

  function getCustomParamByUniqueName(uniqueName) {
    var allCustomParams = MDIGITAL_CONFIGURATION.getOnsiteConfiguration().customParams || [];
    return allCustomParams.find(function(cp) { return cp.unique_name === uniqueName; });
  }

  function getCustomParamById(fieldId, formData) {
    if (fieldId !== undefined && formData && formData.customParams && formData.customParams.length) {
      var allCustomParams = MDIGITAL_CONFIGURATION.getOnsiteConfiguration().customParams || [];
      return allCustomParams.find(cp => Number(cp.id) === Number(fieldId)) || null;
    }
    else {
      return null;
    }
  }

  function fetchCPValue(cp){
    var currentCPValue = cp.value;
    var sourceCP = (cp.source || 'var').toLowerCase();
    var cpName = cp.name || cp.source_name || '';
      switch (KAMPYLE_UTILS.safeToLower(sourceCP)) {
        case 'var':
          currentCPValue = KAMPYLE_UTILS.getNestedPropertyValue(window, cpName);
          break;
        case 'url':
          currentCPValue = KAMPYLE_UTILS.getUrlParam(cpName);
          break;
          case 'cookie':
            currentCPValue = KAMPYLE_UTILS.getCookie(cpName);
            break;
        default:
          currentCPValue = null;
          break;
      }
        return currentCPValue !== '' ? currentCPValue : null;
    }
  function extractCPValue(cp) {
    // not adding robustness here because it is aux function
    // being used by the main function only (getCustomParamValue) where fallback to empty object already done
    // before being past to this function
    var value = cp.value;
    if (value === undefined) {
   value = fetchCPValue(cp);
    }
    return value !== '' ? value : null;
  }

  function castCPValue(value, type) {
    if (value === null) { return value; }
    switch(type.toLowerCase()) {
      case 'datetime':
        return CUSTOM_PARAMETERS.handleDatetimeCasting(value);
      case 'number':
        return KAMPYLE_UTILS.getNumericValue(value)
      case 'text':
        return CUSTOM_PARAMETERS.handleTextCasting(value);
      case 'boolean':
        return CUSTOM_PARAMETERS.handleBooleanCasting(value);
      default:
        console.error('Invalid custom parameter type ' + type);
        return null;
    }
  }

  function handleDatetimeCasting(value) {
    //Special case where the timestamp is a string
    if (typeof value === 'string') {
      return Number(value) || null;
    } else if (!(value instanceof Date) && (!(value || {}).getTime || isNaN(value.getTime()))) { //invalid date will give isNaN(currParamVal.getTime() true
      return null;
    } else {
      return value.getTime();
    }
  }

  function handleTextCasting(value) {
    return (typeof value === 'string') ? value : null;
  }

  function handleBooleanCasting(value) {
    if (value === 'true') {
      return true;
    } else if (value === 'false') {
      return false
    }
    return (typeof value === 'boolean') ? value : null;
  }

  function appendValueToCPObject(cp) {
    cp = cp || {};
    var cpValue = CUSTOM_PARAMETERS.getCustomParamValue({
      name: cp.source_name,
      type: cp.type,
      source: cp.source,
    });
    return Object.assign(cp, { value: cpValue });
  }

  export default {
    getCustomParamValue: getCustomParamValue,
    formatCustomParams: formatCustomParams,
    getFormCustomParams: getFormCustomParams,
    hasCustomParams: hasCustomParams,
    fetchCPValue:fetchCPValue,
    getAllCustomParams: getAllCustomParams,
    getCustomParamValueByUniqueName: getCustomParamValueByUniqueName,
    getCustomParamByUniqueName: getCustomParamByUniqueName,
    getCustomParamById: getCustomParamById,
    extractCPValue: extractCPValue,
    castCPValue: castCPValue,
    handleDatetimeCasting: handleDatetimeCasting,
    handleTextCasting: handleTextCasting,
    handleBooleanCasting: handleBooleanCasting,
    appendValueToCPObject: appendValueToCPObject,
  };
